'use client'
import React, { useState } from 'react';

export default function BMICalculator() {
  const [feet, setFeet] = useState('');
  const [inches, setInches] = useState('');
  const [weight, setWeight] = useState('');
  const [bmi, setBmi] = useState('');
  const [status, setStatus] = useState('');

  const calculateBMI = () => {
    const totalInches = parseFloat(feet) * 12 + parseFloat(inches);
    const heightMeters = totalInches * 0.0254;
    const w = parseFloat(weight);

    if (heightMeters > 0 && w > 0) {
      const result = (w / (heightMeters * heightMeters)).toFixed(1);
      setBmi(result);
      setStatus(getBMIStatus(result));
    }
  };

  const getBMIStatus = (bmi: string) => {
    const value = parseFloat(bmi);
    if (value < 18.5) return 'Underweight';
    if (value < 24.9) return 'Normal';
    if (value < 29.9) return 'Overweight';
    return 'Obese';
  };

  return (
    <div className="max-w-2xl mx-auto bg-white border border-gray-100 shadow-lg rounded-2xl p-8 font-sans text-gray-900">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Height - Feet</label>
          <input
            type="number"
            value={feet}
            onChange={(e) => setFeet(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="e.g. 5"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Height - Inches</label>
          <input
            type="number"
            value={inches}
            onChange={(e) => setInches(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="e.g. 7"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-1">Weight (kg)</label>
          <input
            type="number"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            placeholder="e.g. 68"
          />
        </div>

        <div className="md:col-span-2 text-center">
          <button
            onClick={calculateBMI}
            className="bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition"
          >
            Calculate BMI
          </button>
        </div>
      </div>

      {bmi && (
        <div className="mt-8 text-center">
          <p className="text-xl font-semibold">Your BMI: <span className="text-primary">{bmi}</span></p>
          <p className="text-sm text-gray-600">Category: {status}</p>
        </div>
      )}
    </div>
  );
}
